<content-loader [speed]="1" width="368" height="168">
  <svg:path
    d="M0,3.79484139 C0,1.69914023 2.1824106,0 4.87417219,0 L363.125828,0 C365.817589,0 368,1.69914023 368,3.79484139 L368,10 L0,10 L0,3.79484139 Z"
    fill-rule="nonzero"
  />
  <svg:rect x="0" y="10" width="15" height="15" />
  <svg:rect x="150" y="10" width="130" height="15" />
  <svg:rect x="353" y="10" width="15" height="15" />
  <svg:rect x="0" y="20" width="368" height="10" />
  <svg:rect x="280" y="77" width="73" height="12" />
  <svg:rect x="253" y="95" width="100" height="12" />
  <svg:rect x="273" y="50" width="80" height="20" rx="10" />
  <svg:rect x="15" y="43" width="180" height="20" />
  <svg:rect x="89" y="128" width="80" height="25" rx="5" />
  <svg:rect x="199" y="128" width="80" height="25" rx="5" />
  <svg:rect x="15" y="67" width="123" height="20" />
  <svg:rect x="15" y="91" width="165" height="15" />
  <svg:rect x="0" y="28" rx="3" ry="3" width="1" height="139" />
  <svg:rect x="367" y="28" rx="3" ry="3" width="1" height="139" />
  <svg:rect x="0" y="166" rx="3" ry="3" width="368" height="1" />
</content-loader>
